export default __webpack_public_path__ + "static/media/archive-viewing-icon.f878ee06.png";